"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DiscountTypesApi = /** @class */ (function (_super) {
    __extends(DiscountTypesApi, _super);
    function DiscountTypesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Copies an existing `DiscountType` by ID.
     * Copy a DiscountType
     */
    DiscountTypesApi.prototype.actionDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.discountType === null || requestParameters.discountType === undefined) {
                            throw new runtime.RequiredError('discountType', 'Required parameter requestParameters.discountType was null or undefined when calling actionDiscountType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/{discountType}/copy".replace("{" + "discountType" + "}", encodeURIComponent(String(requestParameters.discountType))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CopyDiscountTypeToJSON(requestParameters.copyDiscountType),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountType1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Copies an existing `DiscountType` by ID.
     * Copy a DiscountType
     */
    DiscountTypesApi.prototype.actionDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionDiscountTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `DiscountType` (or Promo Code). You can choose where a `DiscountType` can be applied, i.e. in the app only, on the booking engine only, or on both. When configured for in-app use only, the `DiscountType` has fewer customisable options and can only be applied to an order by the spa. When configured for use on the booking engine only, the `DiscountType` is a Promo Code which the customer enters for a discount on their order. When configured for use on both the app and the booking engine, the spa can enter a Promo Code on an order on the customer\'s behalf.
     * Create a DiscountType
     */
    DiscountTypesApi.prototype.createDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateDiscountTypeToJSON(requestParameters.createDiscountType),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountType1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `DiscountType` (or Promo Code). You can choose where a `DiscountType` can be applied, i.e. in the app only, on the booking engine only, or on both. When configured for in-app use only, the `DiscountType` has fewer customisable options and can only be applied to an order by the spa. When configured for use on the booking engine only, the `DiscountType` is a Promo Code which the customer enters for a discount on their order. When configured for use on both the app and the booking engine, the spa can enter a Promo Code on an order on the customer\'s behalf.
     * Create a DiscountType
     */
    DiscountTypesApi.prototype.createDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDiscountTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Soft deletes a `DiscountType` by ID.
     * Archive a DiscountType
     */
    DiscountTypesApi.prototype.deleteDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.discountType === null || requestParameters.discountType === undefined) {
                            throw new runtime.RequiredError('discountType', 'Required parameter requestParameters.discountType was null or undefined when calling deleteDiscountType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/{discountType}".replace("{" + "discountType" + "}", encodeURIComponent(String(requestParameters.discountType))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Soft deletes a `DiscountType` by ID.
     * Archive a DiscountType
     */
    DiscountTypesApi.prototype.deleteDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteDiscountTypeRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves a `DiscountType` by ID.
     * Show a DiscountType
     */
    DiscountTypesApi.prototype.getDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.discountType === null || requestParameters.discountType === undefined) {
                            throw new runtime.RequiredError('discountType', 'Required parameter requestParameters.discountType was null or undefined when calling getDiscountType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/{discountType}".replace("{" + "discountType" + "}", encodeURIComponent(String(requestParameters.discountType))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountType1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves a `DiscountType` by ID.
     * Show a DiscountType
     */
    DiscountTypesApi.prototype.getDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDiscountTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint lists all the `DiscountTypes` which are associated to the provided site.
     * List DiscountTypes
     */
    DiscountTypesApi.prototype.listDiscountTypesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling listDiscountTypes.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.archived !== undefined) {
                            queryParameters['archived'] = requestParameters.archived;
                        }
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        if (requestParameters.applicableFor !== undefined) {
                            queryParameters['applicable_for'] = requestParameters.applicableFor;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListDiscountTypesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint lists all the `DiscountTypes` which are associated to the provided site.
     * List DiscountTypes
     */
    DiscountTypesApi.prototype.listDiscountTypes = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listDiscountTypesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint returns an ordered list of all the `DiscountTypes` which are associated with the provided site.
     * Order DiscountTypes
     */
    DiscountTypesApi.prototype.listOrderedDiscountTypesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling listOrderedDiscountTypes.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/order",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListOrderedDiscountTypesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint returns an ordered list of all the `DiscountTypes` which are associated with the provided site.
     * Order DiscountTypes
     */
    DiscountTypesApi.prototype.listOrderedDiscountTypes = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listOrderedDiscountTypesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Restores an archived (soft-deleted) `DiscountType` by ID.
     * Restore a DiscountType
     */
    DiscountTypesApi.prototype.restoreDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.discountType === null || requestParameters.discountType === undefined) {
                            throw new runtime.RequiredError('discountType', 'Required parameter requestParameters.discountType was null or undefined when calling restoreDiscountType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/{discountType}/restore".replace("{" + "discountType" + "}", encodeURIComponent(String(requestParameters.discountType))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountType1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Restores an archived (soft-deleted) `DiscountType` by ID.
     * Restore a DiscountType
     */
    DiscountTypesApi.prototype.restoreDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.restoreDiscountTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates a `DiscountType` by ID.
     * Update a DiscountType
     */
    DiscountTypesApi.prototype.updateDiscountTypeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.discountType === null || requestParameters.discountType === undefined) {
                            throw new runtime.RequiredError('discountType', 'Required parameter requestParameters.discountType was null or undefined when calling updateDiscountType.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/{discountType}".replace("{" + "discountType" + "}", encodeURIComponent(String(requestParameters.discountType))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateDiscountTypeToJSON(requestParameters.updateDiscountType),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountType1FromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates a `DiscountType` by ID.
     * Update a DiscountType
     */
    DiscountTypesApi.prototype.updateDiscountType = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDiscountTypeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint updates the order of the `DiscountTypes` which are associated with the provided site.
     * Update the DiscountTypes order
     */
    DiscountTypesApi.prototype.updateDiscountTypeOrderRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/discount-types/order",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateDiscountTypeOrderToJSON(requestParameters.updateDiscountTypeOrder),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListOrderedDiscountTypesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint updates the order of the `DiscountTypes` which are associated with the provided site.
     * Update the DiscountTypes order
     */
    DiscountTypesApi.prototype.updateDiscountTypeOrder = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDiscountTypeOrderRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DiscountTypesApi;
}(runtime.BaseAPI));
exports.DiscountTypesApi = DiscountTypesApi;
/**
    * @export
    * @enum {string}
    */
var ListDiscountTypesApplicableForEnum;
(function (ListDiscountTypesApplicableForEnum) {
    ListDiscountTypesApplicableForEnum["Only"] = "app_only";
    ListDiscountTypesApplicableForEnum["AndBookingEngine"] = "app_and_booking_engine";
})(ListDiscountTypesApplicableForEnum = exports.ListDiscountTypesApplicableForEnum || (exports.ListDiscountTypesApplicableForEnum = {}));
